module.exports = __webpack_public_path__ + "img/rooms_status.b9509e9e.svg";